// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.box-visualizar[data-v-2db2e238] {\n    border-top:.75rem solid var(--primaryColor, #a82339);\n    border-left:1rem solid #666666;\n    border-radius:8px;\n    padding:2em;\n    width:100%;\n    max-width:700px;\n    box-sizing: border-box;\n    box-shadow:2px 2px 2px #70757a66\n}\n", ""]);
// Exports
module.exports = exports;
